// extracted by mini-css-extract-plugin
export default {"logout":"styles_logout__7Ha8K"};